import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Logo from "../elements/Logo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPerson,
  faHouse,
  faServer,
  faHistory,
  faProjectDiagram,
  faBlog,
  faContactBook,
  faSurprise,
} from "@fortawesome/free-solid-svg-icons";
import MediaQuery from "react-responsive";

function Header({ light, logoSource, toggleMenu, headerToggler }) {
  const handleClasses = () => {
    let classes = "desktop-header-1 d-flex align-items-start flex-column";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };

  const handleMobileClasses = () => {
    let classes = "mobile-header-1";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };

  // const isDesktopOrLaptop = useMediaQuery({
  //   query: "(min-width: 1000px)",
  // });

  // useEffect(() => {

  //     console.log("You are a desktop or laptop: ", isDesktopOrLaptop);

  // }, [isDesktopOrLaptop]);

  return (
    <>
      <header className={handleMobileClasses()}>
        <div className="container">
          <div className="menu-icon d-inline-flex mr-4">
            <button onClick={headerToggler}>
              <span></span>
            </button>
          </div>
          <Logo logoSource={logoSource} />
        </div>
      </header>
      <header className={handleClasses()}>
        <Logo logoSource={logoSource} />
        <nav>
          <ul className="vertical-menu scrollspy">
            <li>
              <Link
                activeClass="active"
                to="/"
                spy={true}
                smooth={true}
                duration={500}
              >
                <FontAwesomeIcon icon={faHouse} />
                {"  "}Accueil
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="/blog"
                // to="section-blogs"
              >
                <FontAwesomeIcon icon={faBlog} />
                {"  "}Blog
              </Link>
            </li>
            <MediaQuery minWidth={1000}>
              <li className="forWeb">
                <Link
                  activeClass="active"
                  to="/superservice"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className={"superbutton"}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <FontAwesomeIcon icon={faSurprise} /> Super Services
                </Link>
              </li>
            </MediaQuery>
          </ul>
        </nav>

        <div className="footer">
          <span className="copyright">
            &copy; {new Date().getFullYear()} Powered by Yabsaka.
          </span>
        </div>
      </header>
    </>
  );
}

export default Header;
